import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ImageryProviderService} from "../../services/imageryProvider/imagery-provider.service";
import {CanvasStoreComponent} from "../canvas-store/canvas-store.component";
import {isViewMode} from "../../../configs/view_only";
import { ES_APP_VERSION } from 'src/app/interfaces/constants';
declare var Yiit;
@Component({
  selector: 'app-map-views',
  templateUrl: './map-views.component.html',
  styleUrls: ['./map-views.component.scss']
})
export class MapViewsComponent implements OnInit {

  public viewModes = [];
  public selectedMode = null;
  public isViewMode = isViewMode;
  public Yiit = Yiit;

  @ViewChild(CanvasStoreComponent, {static: false})
  protected canvasStoreComponent: CanvasStoreComponent;
  ES_APP_VERSION = ES_APP_VERSION;

  constructor(protected provider: ImageryProviderService, protected cd: ChangeDetectorRef) { }

  selectViewMode(name, mode){

    if (this.selectedMode === mode['id']) {
      return;
    }

    this.provider.selectViewMode(name, mode);
    this.selectedMode = mode['id'];
  }

  hasViewModes() {
    return this.viewModes.length > 0;
  }

  get isVisibleAppVersion(){
    return window.location && window.location.search && window.location.search.indexOf('show_version') >= 0
  }


  private getViewModes(providers){
    let resultArr = [];
    for (let i in providers){
      if (providers.hasOwnProperty(i)){
        if (providers[i].id == '-1'){
          resultArr.unshift({key: i, value: providers[i]});
        }
        else{
          resultArr.push({key: i, value: providers[i]});
        }
      }
    }
    return resultArr;
  }

  ngOnInit(): void {
    this.provider.imageryLoaded.subscribe((providers)=>{
      if (!providers){
        return;
      }
      this.viewModes = this.getViewModes(providers);

      this.cd.detectChanges();
      // this.viewModes = providers;
      // if (!this.selectedMode && Object.keys(this.viewModes).length > 0) {
      //   this.selectedMode = Object.values(this.viewModes)[0]['id'];
      // }
    });


    this.provider.selectedModeChanged.subscribe(({name, mode})=>{
      if (this.selectedMode == mode['id']) {
        return;
      }

      this.selectedMode = mode['id'];
      this.cd.detectChanges();
    })

  }

  openModal() {
    this.canvasStoreComponent.show();
  }

}
